import React, { useState, useEffect } from 'react';
import { useTheme } from '../../../ThemeContext';
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import '../../../common-ui.css';
import './Form360.css';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import Breadcrumb from '../../Layouts/Breadcrumb';
import CardContent from '@material-ui/core/CardContent';
import { Card, Button, Select, MenuItem, FormControl, InputLabel, CircularProgress, TextField, FormLabel } from '@material-ui/core';
import Authapi from '../../Services/Authapi';
import swal from 'sweetalert';
import ls from 'local-storage';
import { Dialog, DialogTitle, DialogContent, TablePagination } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import AuthCheckComponent from '../../Layouts/Token';
import { IconButton, Tooltip } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import FontAwesomeIconComponent from '../../Layouts/FontAwesomeIconComponent';
import CommonTablePaginationActions, {
  COMMON_PAGINATION_CLASS,
  commonPaginationSelectProps,
  getCommonPaginationStyle,
} from '../../Common/commonPagination';
import TableComponent from '../../Layouts/TableComponent';

// Exact same StyledTableRow as TableComponent
const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#f5f5f5',
    },
    '&.dark-theme &:nth-of-type(odd), .dark-theme &:nth-of-type(odd)': {
      backgroundColor: '#2a2a2a !important',
    },
    '&:hover': {
      backgroundColor: '#c2cddf !important',
    },
    '&.dark-theme &:hover, .dark-theme &:hover': {
      backgroundColor: '#2b3744 !important',
    },
  },
}))(TableRow);

// Exact same useStyles as TableComponent
const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  head: {
    backgroundColor: '#036dda',
    color: '#fff',
    margin: '0 auto',
    '& th': { color: '#fff' },
    '& th > span:hover': { color: '#fff' },
    '& th:hover': { color: '#fff' },
    '& th:active': { color: '#fff' },
    '& th > span:active': { color: '#fff' },
  },
});

export default function Form360(props) {
  const navigationButtonStyle = {
    textTransform: 'capitalize',
  };

  const previousButtonStyle = {
    ...navigationButtonStyle,
  };

  const renderRequiredLabel = (label) => (
    <>
      {label} <span className="required-asterisk">*</span>
    </>
  );

  const getSelectedValues = (value, options = []) => {
    if (value === null || value === undefined || value === "") return [];

    if (Array.isArray(value)) {
      return value.map(v => (v !== null && v !== undefined) ? v.toString().trim() : '').filter(Boolean);
    }

    const strVal = value.toString().trim();
    if (!strVal) return [];

    // If options array is provided and not empty, check option matching
    if (Array.isArray(options) && options.length > 0) {
      const validOptions = options.map(opt => (opt !== null && opt !== undefined) ? opt.toString().trim() : '');

      // Direct exact match with one of the options
      if (validOptions.includes(strVal)) {
        return [strVal];
      }

      // Check if multiple options are joined in strVal
      const matched = [];
      const sortedOptions = [...validOptions].filter(Boolean).sort((a, b) => b.length - a.length);
      let tempVal = strVal;

      for (const opt of sortedOptions) {
        if (tempVal.includes(opt)) {
          matched.push(opt);
          tempVal = tempVal.replace(opt, '');
        }
      }

      if (matched.length > 0) {
        return validOptions.filter(opt => matched.includes(opt));
      }
    }

    // Fallback: Split by comma if options matching didn't yield results
    return strVal.split(',').map((item) => item.trim()).filter(Boolean);
  };

  const findValueInRowData = (rowData, targetLabel) => {
    let parsedData = rowData;
    if (typeof parsedData === 'string') {
      try {
        parsedData = JSON.parse(parsedData);
      } catch (e) {
        return "";
      }
    }

    if (!parsedData || typeof parsedData !== 'object') return "";

    const normTarget = (targetLabel || "").toString().trim().toLowerCase().replace(/_/g, ' ');
    if (!normTarget) return "";

    // 1. Direct key lookup in rowData (flat structure)
    for (const [key, val] of Object.entries(parsedData)) {
      const normKey = key.toString().trim().toLowerCase().replace(/_/g, ' ');
      if (normKey === normTarget) {
        return val;
      }
    }

    // 2. Nested lookup in section objects
    for (const sectionVal of Object.values(parsedData)) {
      if (sectionVal && typeof sectionVal === 'object' && !Array.isArray(sectionVal)) {
        for (const [key, val] of Object.entries(sectionVal)) {
          const normKey = key.toString().trim().toLowerCase().replace(/_/g, ' ');
          if (normKey === normTarget) {
            return val;
          }
        }
      }
    }

    return "";
  };

  const getQuestionLabel = (item = {}) =>
    item.label ||
    item.input_label ||
    item.content_label ||
    item.field_label ||
    item.question_label ||
    item.input_name ||
    item.field_name ||
    item.name ||
    item.lable ||
    "";
  const getQuestionTitle = (item = {}) => item.title || item.form_title || item.section_title || "";
  const normalizeOptions = (options) => (Array.isArray(options) ? options : []);
  const normalizeFormDetail = (item = {}) => ({
    ...item,
    label: getQuestionLabel(item),
    type: item.type || "text",
    options: normalizeOptions(item.options),
  });
  const normalizeFormContent = (item = {}) => ({
    ...item,
    title: getQuestionTitle(item),
    label: getQuestionLabel(item),
    type: item.type || "text",
    options: normalizeOptions(item.options),
  });
  const classes = useStyles();

  // if you don't have ThemeContext, you can remove useTheme usage below
  let darkMode = false;
  try {
    const theme = useTheme();
    darkMode = theme?.darkMode || false;
  } catch (e) {
    // ignore if useTheme not provided
    darkMode = false;
  }

  const User = ls("user");
  const role = ls("roles") || ls("role") || null;
  const isSuperAdmin = role === "Super Admin" || role === "Admin";
  const userAccess = ls("userAccess") || [];

  const userpermissions = (User && Array.isArray(User.roles) && User.roles[0] && Array.isArray(User.roles[0].permissions))
    ? User.roles[0].permissions.map(permissionObj => permissionObj.name)
    : [];

  const hasPermission = (permissionName) => {
    if (isSuperAdmin) return true;
    return userpermissions.includes(permissionName) || userAccess.includes(permissionName);
  };

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [currentSection, setCurrentSection] = useState(-1);
  const [responses, setResponses] = useState({});
  const [formDetails, setFormDetails] = useState({});
  const [data, setData] = useState(null);
  const [reviewformlist, setReviewformlist] = useState([]);
  const [reviewformlistdata, setReviewformlistdata] = useState([]);
  const [selectedFormId, setSelectedFormId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [viewMode, setViewMode] = useState(hasPermission("Form360.List") ? 'list' : '');
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [totalSelections, setTotalSelections] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedBulkAction, setSelectedBulkAction] = useState('');
  const [isListLoading, setIsListLoading] = useState(true);

  const tableTh = [
    { id: 'select', numeric: false, disablePadding: true, label: '', sortable: false },
    { id: 'serial_number', numeric: false, disablePadding: true, label: 'Sr. No', sortable: true },
    { id: 'form_name', numeric: false, disablePadding: true, label: 'Form Title', sortable: true },
    { id: 'first_name', numeric: false, disablePadding: true, label: 'User Name', sortable: true },
    { id: 'actions', numeric: false, disablePadding: true, label: 'Actions', sortable: false },
  ];

  useEffect(() => {
    Reviewformlisttitle();
    Reviewformdynamiclistid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // -----------------------
  // API / Data functions
  // -----------------------
  const Reviewformlisttitle = async () => {
    try {
      let res = await Authapi.Reviewformlist();
      if (res && res.data) setReviewformlist(res.data);
    } catch (error) {
      console.error('Error fetching Reviewformlist:', error);
    }
  };

  const Reviewformdynamiclistid = async () => {
    setIsListLoading(true);
    try {
      const user = ls('user') || {};
      const userid = user.id;
      const role = ls('roles') || ls('role') || null; // attempt both keys
      // If your Authapi exposes different functions, prefer one that exists
      if (role === "Super Admin" && Authapi.Reviewformdynamiclist) {
        const resp = await Authapi.Reviewformdynamiclist(userid);
        if (resp && resp.data) {
          setReviewformlistdata(resp.data);
          setSelectedRows((prevSelected) =>
            prevSelected.filter((id) => resp.data.some((item) => item.id === id))
          );
        }
        else {
          setReviewformlistdata([]);
          setSelectedRows([]);
        }
      } else if (Authapi.Reviewformdynamiclistid) {
        const resp = await Authapi.Reviewformdynamiclistid(userid);
        if (resp && resp.data) {
          setReviewformlistdata(resp.data);
          setSelectedRows((prevSelected) =>
            prevSelected.filter((id) => resp.data.some((item) => item.id === id))
          );
        }
        else {
          setReviewformlistdata([]);
          setSelectedRows([]);
        }
      } else if (Authapi.Reviewformdynamiclist) {
        // fallback if only Reviewformdynamiclist exists
        const resp = await Authapi.Reviewformdynamiclist(userid);
        if (resp && resp.data) {
          setReviewformlistdata(resp.data);
          setSelectedRows((prevSelected) =>
            prevSelected.filter((id) => resp.data.some((item) => item.id === id))
          );
        }
        else {
          setReviewformlistdata([]);
          setSelectedRows([]);
        }
      }
    } catch (error) {
      console.error('Error fetching Reviewformdynamiclistid:', error);
      setReviewformlistdata([]);
      setSelectedRows([]);
    } finally {
      setIsListLoading(false);
    }
  };

  const fetchFormDetailsById = async (formId) => {
    try {
      const role = await Authapi.ReviewformlistgetformbyID(formId);
      if (role && role.data) {
        setData({
          ...role.data,
          form_details: (role.data.form_details || []).map(normalizeFormDetail),
          form_content: (role.data.form_content || []).map(normalizeFormContent),
        });
        // reset section to beginning for new form
        setCurrentSection(-1);
        setErrors({});
        setTouched({});
        setFormDetails({});
        setResponses({});
      }
    } catch (error) {
      console.error('Error fetching form details:', error);
    }
  };

  // -----------------------
  // Handlers
  const validateSingleField = (label, value, type, isRequired, options = []) => {
    const valStr = value !== undefined && value !== null ? value.toString().trim() : '';
    const labelLower = (label || '').toLowerCase();
    const typeLower = (type || '').toLowerCase();

    // Required check
    if (isRequired !== false) {
      if (typeLower === 'checkbox') {
        const selectedOptions = getSelectedValues(value, options);
        if (!selectedOptions || selectedOptions.length === 0) {
          return `${label} is required`;
        }
      } else if (!valStr) {
        return `${label} is required`;
      }
    }

    if (!valStr) return null;

    // Email validation
    if (typeLower === 'email' || labelLower.includes('email')) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(valStr)) {
        return `Please enter a valid email address`;
      }
    }

    // Contact Number / Phone validation
    if (typeLower === 'tel' || labelLower.includes('contact') || labelLower.includes('phone') || labelLower.includes('mobile')) {
      const digits = valStr.replace(/[\s\-\+\(\)]/g, '');
      if (!/^[0-9]{10}$/.test(digits)) {
        return `Please enter a valid 10-digit contact number`;
      }
    }

    // Number validation
    if (typeLower === 'number') {
      if (isNaN(valStr)) {
        return `Please enter a valid number`;
      }
    }

    return null;
  };

  // -----------------------
  // Dynamic Form Handlers
  // -----------------------
  const handleDetailBlur = (label, value, type = 'text') => {
    setTouched((prev) => ({ ...prev, [label]: true }));
    const detailObj = data?.form_details?.find(d => getQuestionLabel(d) === label);
    const isRequired = detailObj ? detailObj.required !== false : true;
    const err = validateSingleField(label, value, type, isRequired, detailObj?.options);

    setErrors((prevErrors) => {
      if (err) {
        return { ...prevErrors, [label]: err };
      } else {
        const { [label]: removed, ...rest } = prevErrors;
        return rest;
      }
    });
  };

  const handleDetailChange = (label, value, type = 'text') => {
    const detailObj = data?.form_details?.find(d => getQuestionLabel(d) === label);
    let updatedVal;
    if (type === 'checkbox') {
      const existingSelections = getSelectedValues(formDetails[label], detailObj?.options);
      updatedVal = existingSelections.includes(value)
        ? existingSelections.filter((item) => item !== value)
        : [...existingSelections, value];
    } else {
      updatedVal = value;
    }

    const isRequired = detailObj ? detailObj.required !== false : true;
    const err = validateSingleField(label, updatedVal, type, isRequired, detailObj?.options);

    if (type === 'radio' || type === 'checkbox') {
      setTouched((prev) => ({ ...prev, [label]: true }));
    }

    setErrors((prevErrors) => {
      const isTouched = touched[label] || type === 'radio' || type === 'checkbox';
      const hasExistingError = !!prevErrors[label];

      if (err) {
        if (isTouched || hasExistingError) {
          return { ...prevErrors, [label]: err };
        } else {
          return prevErrors;
        }
      } else {
        const { [label]: removed, ...rest } = prevErrors;
        return rest;
      }
    });

    setFormDetails((prev) => ({
      ...prev,
      [label]: updatedVal,
    }));
  };

  const handleResponseBlur = (sectionIndex, questionIndex, value, label, type) => {
    setTouched((prev) => ({ ...prev, [label]: true }));
    const questionObj = data?.form_content?.find(q => getQuestionLabel(q) === label);
    const isRequired = questionObj ? questionObj.required !== false : true;
    const err = validateSingleField(label, value, type, isRequired, questionObj?.options);

    setErrors((prevErrors) => {
      if (err) {
        return { ...prevErrors, [label]: err };
      } else {
        const { [label]: removed, ...rest } = prevErrors;
        return rest;
      }
    });
  };

  const handleResponseChange = (sectionIndex, questionIndex, value, label, type) => {
    const questionObj = data?.form_content?.find(q => getQuestionLabel(q) === label);
    let updatedQuestionResponses;
    const currentSectionResponses = responses[sectionIndex] || {};
    const currentQuestionResponses = currentSectionResponses[label] || "";

    if (type === 'checkbox') {
      const selectedOptions = getSelectedValues(currentQuestionResponses, questionObj?.options);
      if (selectedOptions.includes(value)) {
        updatedQuestionResponses = selectedOptions.filter(item => item !== value);
      } else {
        updatedQuestionResponses = [...selectedOptions, value];
      }
    } else {
      updatedQuestionResponses = value;
    }

    const isRequired = questionObj ? questionObj.required !== false : true;
    const err = validateSingleField(label, updatedQuestionResponses, type, isRequired, questionObj?.options);

    if (type === 'radio' || type === 'checkbox') {
      setTouched((prev) => ({ ...prev, [label]: true }));
    }

    setErrors((prevErrors) => {
      const isTouched = touched[label] || type === 'radio' || type === 'checkbox';
      const hasExistingError = !!prevErrors[label];

      if (err) {
        if (isTouched || hasExistingError) {
          return { ...prevErrors, [label]: err };
        } else {
          return prevErrors;
        }
      } else {
        const { [label]: removed, ...rest } = prevErrors;
        return rest;
      }
    });

    setResponses((prevResponses) => {
      // Update totalSelections for radio type (optional)
      if (type === 'radio') {
        const newResponses = {
          ...prevResponses,
          [sectionIndex]: {
            ...currentSectionResponses,
            [label]: updatedQuestionResponses
          }
        };
        let count = 0;
        Object.values(newResponses).forEach(section => {
          Object.values(section || {}).forEach(v => {
            if (v && v.toString().trim() !== '') count++;
          });
        });
        setTotalSelections(count);
      }

      return {
        ...prevResponses,
        [sectionIndex]: {
          ...currentSectionResponses,
          [label]: updatedQuestionResponses
        }
      };
    });
  };

  const validateForm = () => {
    const newErrors = {};
    const newTouched = { ...touched };
    if (currentSection === -1 && data?.form_details) {
      data.form_details.forEach(detail => {
        const detailLabel = getQuestionLabel(detail);
        newTouched[detailLabel] = true;
        const detailValue = formDetails[detailLabel];
        const isRequired = detail.required !== false;
        const err = validateSingleField(detailLabel, detailValue, detail.type, isRequired, detail.options);
        if (err) {
          newErrors[detailLabel] = err;
        }
      });
    } else if (data && data.form_content) {
      const uniqueTitles = Array.from(new Set(data.form_content.map(content => getQuestionTitle(content))));
      const currentTitle = uniqueTitles[currentSection];
      if (currentTitle) {
        data.form_content
          .filter(content => getQuestionTitle(content) === currentTitle)
          .forEach(question => {
            const questionLabel = getQuestionLabel(question);
            newTouched[questionLabel] = true;
            const questionValue = responses[currentSection]?.[questionLabel];
            const isRequired = question.required !== false;
            const err = validateSingleField(questionLabel, questionValue, question.type, isRequired, question.options);
            if (err) {
              newErrors[questionLabel] = err;
            }
          });
      }
    }
    setTouched(newTouched);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitted(true);
      setViewMode("list");
    } else {
      console.log("Validation failed", errors);
    }
  };

  const createLeaves = async () => {
    const serializeCheckboxValues = (source = {}) =>
      Object.entries(source).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: Array.isArray(value) ? value.join(', ') : value
      }), {});

    const finalPostData = {
      ...serializeCheckboxValues(formDetails),
      ...Object.values(responses).reduce(
        (acc, section) => ({ ...acc, ...serializeCheckboxValues(section) }),
        {}
      )
    };

    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode()
    });

    try {
      const create = await Authapi.Reviewformdynamicadd(finalPostData, data?.form_name);
      swal.close();
      if (create && create.status === true) {
        setViewMode("list");
        Reviewformdynamiclistid();
        swal("Success", "Form submitted successfully!", "success");
      } else {
        const apiError = (create && create.message) ? create.message : "Form submission failed. Please check field details.";
        swal("Error", apiError, "error");
      }
    } catch (error) {
      swal.close();
      console.error("Error creating record:", error);
      swal("Error", "Server error while submitting form", "error");
    }
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    if (currentSection === -1) {
      setCurrentSection(0);
    } else if (data && data.form_content) {
      const uniqueTitles = [...new Set(data.form_content.map(item => getQuestionTitle(item)))];
      if (currentSection < uniqueTitles.length - 1) {
        setCurrentSection(prev => prev + 1);
      } else if (currentSection === uniqueTitles.length - 1) {
        // last section -> create or update
        if (viewMode === 'editForm') {
          await updateLeaves();
        } else {
          await createLeaves();
        }
      }
    }
  };

  const handlePrevious = () => {
    if (currentSection > 0) setCurrentSection(prev => prev - 1);
    else if (currentSection === 0) setCurrentSection(-1);
  };

  const handleFormSelect = (event) => {
    const formId = event.target.value;
    setSelectedFormId(formId);
    fetchFormDetailsById(formId);
  };

  const handleViewClick = (row) => {
    setSelectedData(row);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedData(null);
  };

  const handleViewModeChange = (event) => {
    setViewMode(event.target.value);
    if (event.target.value === "addForm" || event.target.value === "list") {
      setIsSubmitted(false);
      resetForm();
    }
  };

  const resetForm = () => {
    setFormDetails({});
    setResponses({});
    setCurrentSection(-1);
    setErrors({});
    setTouched({});
    setData(null);
    setSelectedFormId(null);
    setSelectedData(null);
  };

  const startEditing = async (row) => {
    const template = reviewformlist.find(f => f.form_name === row.form_name);
    if (!template) {
      swal("Error", "Form template not found", "error");
      return;
    }
    
    try {
      const role = await Authapi.ReviewformlistgetformbyID(template.id);
      if (role && role.data) {
        const formTemplate = {
          ...role.data,
          form_details: (role.data.form_details || []).map(normalizeFormDetail),
          form_content: (role.data.form_content || []).map(normalizeFormContent),
        };
        setData(formTemplate);
        setSelectedFormId(template.id);
        
        const newFormDetails = {};
        const newResponses = {};
        
        formTemplate.form_details.forEach(detail => {
          const label = getQuestionLabel(detail);
          newFormDetails[label] = findValueInRowData(row.data, label);
        });
        
        const uniqueTitles = Array.from(new Set(formTemplate.form_content.map(content => getQuestionTitle(content))));
        uniqueTitles.forEach((title, sectionIndex) => {
          newResponses[sectionIndex] = {};
          formTemplate.form_content
            .filter(content => getQuestionTitle(content) === title)
            .forEach(question => {
              const label = getQuestionLabel(question);
              newResponses[sectionIndex][label] = findValueInRowData(row.data, label);
            });
        });
        
        setFormDetails(newFormDetails);
        setResponses(newResponses);
        setCurrentSection(-1);
        setErrors({});
        setTouched({});
        setSelectedData(row);
        setViewMode("editForm");
      }
    } catch (error) {
      console.error("Error loading edit form:", error);
      swal("Error", "Unable to load form data for editing", "error");
    }
  };

  const updateLeaves = async () => {
    const serializeCheckboxValues = (source = {}) =>
      Object.entries(source).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: Array.isArray(value) ? value.join(', ') : value
      }), {});

    const finalPostData = {
      ...serializeCheckboxValues(formDetails),
      ...Object.values(responses).reduce(
        (acc, section) => ({ ...acc, ...serializeCheckboxValues(section) }),
        {}
      )
    };

    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode()
    });

    try {
      const update = await Authapi.Reviewformdynamicupdate(selectedData.id, finalPostData);
      swal.close();
      if (update && update.status === true) {
        setViewMode("list");
        setSelectedData(null);
        Reviewformdynamiclistid();
        swal("Success", "Form updated successfully!", "success");
      } else {
        const apiError = (update && update.message) ? update.message : "Form update failed. Please check field details.";
        swal("Error", apiError, "error");
      }
    } catch (error) {
      swal.close();
      console.error("Error updating record:", error);
      swal("Error", "Server error while updating form", "error");
    }
  };

  const handleDeleteClick = async (formId) => {
    swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: ["Cancel", "Yes"]
    }).then(async (confirm) => {
      if (confirm) {
        try {
          const resp = await Authapi.Reviewformdynamicdelete(formId);
          if (resp && resp.status === true) {
            Reviewformdynamiclistid();
            swal("Success", "Form deleted successfully!", "success");
          } else {
            swal("Error", "Unable to delete", "error");
          }
        } catch (err) {
          console.error("Error deleting:", err);
          swal("Error", "Server error while deleting", "error");
        }
      }
    });
  };

  const paginatedRows = (reviewformlistdata || []).slice(page * pageSize, page * pageSize + pageSize);
  const isAllCurrentPageSelected = paginatedRows.length > 0 && paginatedRows.every((row) => selectedRows.includes(row.id));
  const isPartialCurrentPageSelected = paginatedRows.some((row) => selectedRows.includes(row.id)) && !isAllCurrentPageSelected;

  const handleSelectAllCurrentPage = (event) => {
    if (event.target.checked) {
      const currentPageIds = paginatedRows.map((row) => row.id);
      setSelectedRows((prevSelected) => Array.from(new Set([...prevSelected, ...currentPageIds])));
      return;
    }

    const currentPageIds = paginatedRows.map((row) => row.id);
    setSelectedRows((prevSelected) => prevSelected.filter((id) => !currentPageIds.includes(id)));
  };

  const handleSelectRow = (id) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((selectedId) => selectedId !== id)
        : [...prevSelected, id]
    );
  };

  const handleBulkDelete = async () => {
    if (selectedRows.length === 0) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: `Selected ${selectedRows.length} form(s) will be deleted.`,
      icon: "warning",
      buttons: ["Cancel", "Yes"]
    }).then(async (confirm) => {
      if (!confirm) {
        return;
      }

      try {
        const results = await Promise.allSettled(
          selectedRows.map((formId) => Authapi.Reviewformdynamicdelete(formId))
        );
        const successCount = results.filter(
          (result) => result.status === "fulfilled" && result.value?.status === true
        ).length;

        if (successCount === selectedRows.length) {
          swal("Success", "Selected forms deleted successfully!", "success");
        } else if (successCount > 0) {
          swal("Partial Success", `${successCount} form(s) deleted successfully.`, "warning");
        } else {
          swal("Error", "Unable to delete selected forms", "error");
        }

        Reviewformdynamiclistid();
      } catch (error) {
        console.error("Error bulk deleting forms:", error);
        swal("Error", "Server error while deleting selected forms", "error");
      }
    });
  };

  const handleBulkActionSubmit = () => {
    if (selectedBulkAction === 'delete') {
      handleBulkDelete();
    }
  };

  // -----------------------
  // DataGrid columns
  // -----------------------






  return (
    <div className="form360-container">
      <AuthCheckComponent authToken={props.authToken} />
      <Header
        {...props}
        authUser={props.authUser}
        setAutUser={props.setAutUser}
        component={
          <>
            <div className="holiday-breadcrumb-card">
              <Breadcrumb {...props}
                primaryPageName="Feedback Forms"
                primaryPageLink="/form360"
                isSecondaryPage={false}
                secondaryPageName="" />
            </div>

            <FormControl variant="outlined" className="form-control holiday-form-input form-360-input leave-ticket-form" style={{ width: "82%", marginTop: '20px' }}>
              <InputLabel>Choose Action</InputLabel>
              <Select
                onChange={handleViewModeChange}
                value={viewMode || ''}
                className="styled-select"
                label="Choose Action"
                MenuProps={{
                  PaperProps: {
                    className: "form360-select-menu",
                  },
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                }}
              >
                <MenuItem value="" disabled>Select an action</MenuItem>
                <MenuItem value="addForm">Add Form</MenuItem>
                {hasPermission("Form360.List") && <MenuItem value="list">List</MenuItem>}
                {viewMode === 'editForm' && <MenuItem value="editForm" disabled>Edit Form</MenuItem>}
              </Select>
            </FormControl>

            {(viewMode === 'addForm' || viewMode === 'editForm') && (
              <div style={{ marginTop: '62px' }}>
                {viewMode === 'addForm' && (
                  <FormControl variant="outlined" className="form-control holiday-form-input form-360-input leave-ticket-form" style={{ width: "82%" }}>
                    <InputLabel>Select a form</InputLabel>
                    <Select
                      onChange={handleFormSelect}
                      value={selectedFormId || ''}
                      className="styled-select"
                      label="Select a form"
                      MenuProps={{
                        PaperProps: {
                          className: "form360-select-menu",
                        },
                        getContentAnchorEl: null,
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                      }}
                    >
                      <MenuItem value="" disabled>Select a form</MenuItem>
                      {reviewformlist && reviewformlist.map((form) => (
                        <MenuItem key={form.id} value={form.id}>
                          {form.form_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                {data && (
                  <div className="form-container" style={{ marginBottom: '80px', marginTop: "45px" }}>
                    <form className="common-form-fields leave-ticket-form" onSubmit={handleSubmit}>
                      <Typography variant="h4" className="form-title" style={{ marginBottom: '20px' }}>
                        {data?.form_name} {viewMode === 'editForm' && "(Edit)"}
                      </Typography>

                      {currentSection === -1 && data?.form_details && (
                        <div className={darkMode ? "dark-background" : ""}>
                          <div className="form-row">
                            {data.form_details.map((detail, index) => {
                              const detailLabel = getQuestionLabel(detail);
                              const detailValue = formDetails[detailLabel] || "";
                              const isDetailRequired = detail.required !== false;

                              return (
                                <div className="form-group" key={index} style={{ marginBottom: "20px" }}>
                                  {detail.type === 'radio' ? (
                                    <FormControl component="fieldset" style={{ width: "100%", textAlign: "left", alignItems: "flex-start" }}>
                                      <FormLabel component="legend" className="form-360-legend" required={isDetailRequired} style={{ textAlign: "left", width: "100%", marginLeft: 0 }}>
                                        {detailLabel}
                                      </FormLabel>
                                      <RadioGroup
                                        name={detailLabel}
                                        value={detailValue}
                                        onChange={(e) => handleDetailChange(detailLabel, e.target.value, 'radio')}
                                        style={{ marginTop: "8px" }}
                                      >
                                        {detail.options && detail.options.map((option, idx) => (
                                          <FormControlLabel
                                            key={idx}
                                            value={option}
                                            control={<Radio />}
                                            label={option}
                                          />
                                        ))}
                                      </RadioGroup>
                                    </FormControl>
                                  ) : detail.type === 'checkbox' ? (
                                    <FormControl component="fieldset" style={{ width: "100%", textAlign: "left", alignItems: "flex-start" }}>
                                      <FormLabel component="legend" className="form-360-legend" required={isDetailRequired} style={{ textAlign: "left", width: "100%", marginLeft: 0 }}>
                                        {detailLabel}
                                      </FormLabel>
                                      <div className="checkbox-group" style={{ marginTop: "8px" }}>
                                        {detail.options && detail.options.map((option, idx) => (
                                          <FormControlLabel
                                            key={idx}
                                            control={
                                              <Checkbox
                                                checked={getSelectedValues(formDetails[detailLabel], detail.options).includes(option)}
                                                onChange={() => handleDetailChange(detailLabel, option, 'checkbox')}
                                              />
                                            }
                                            label={option}
                                          />
                                        ))}
                                      </div>
                                    </FormControl>
                                  ) : detail.type === 'select' || detail.type === 'dropdown' ? (
                                    <FormControl
                                      variant="outlined"
                                      fullWidth
                                      required={isDetailRequired}
                                      error={!!errors[detailLabel]}
                                    >
                                      <InputLabel id={`detail-select-label-${index}`}>
                                        {detailLabel}
                                      </InputLabel>
                                      <Select
                                        labelId={`detail-select-label-${index}`}
                                        label={detailLabel}
                                        value={detailValue}
                                        onChange={(e) => handleDetailChange(detailLabel, e.target.value, detail.type)}
                                        onBlur={() => handleDetailBlur(detailLabel, detailValue, detail.type)}
                                        className="styled-select"
                                      >
                                        <MenuItem value="" disabled>Select</MenuItem>
                                        {detail.options && detail.options.map((option, idx) => (
                                          <MenuItem key={idx} value={option}>{option}</MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  ) : detail.type === 'textarea' ? (
                                    <TextField
                                      fullWidth
                                      required={isDetailRequired}
                                      multiline
                                      rows={4}
                                      variant="outlined"
                                      label={detailLabel}
                                      name={detailLabel}
                                      value={detailValue}
                                      onChange={(e) => handleDetailChange(detailLabel, e.target.value, detail.type)}
                                      onBlur={() => handleDetailBlur(detailLabel, detailValue, detail.type)}
                                      error={!!errors[detailLabel]}
                                    />
                                  ) : (
                                    <TextField
                                      fullWidth
                                      required={isDetailRequired}
                                      type={detail.type || "text"}
                                      variant="outlined"
                                      label={detailLabel}
                                      name={detailLabel}
                                      value={detailValue}
                                      onChange={(e) => handleDetailChange(detailLabel, e.target.value, detail.type)}
                                      onBlur={() => handleDetailBlur(detailLabel, detailValue, detail.type)}
                                      error={!!errors[detailLabel]}
                                      InputLabelProps={detail.type === 'date' ? { shrink: true } : undefined}
                                    />
                                  )}

                                  {errors[detailLabel] && (
                                    <span className="field-error">{errors[detailLabel]}</span>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                          <div className="form-group form-actions-right">
                            <Button
                              variant="contained"
                              color="primary"
                              className="common-step-navigation-button"
                              onClick={handleNext}
                              style={navigationButtonStyle}
                            >
                              Next
                            </Button>
                          </div>
                        </div>
                      )}

                      {/* Feedback Sections */}
                      {currentSection >= 0 &&
                        data?.form_content &&
                        currentSection < Array.from(new Set(data.form_content.map(content => getQuestionTitle(content)))).length && (
                          <>
                            <div className="progress-indicator">
                              {Array.from(new Set(data.form_content.map(content => getQuestionTitle(content)))).map((title, index) => {
                                const displayTitle = /^Step\s*\d+$/i.test(title) ? `Step ${index + 1}` : title;
                                return (
                                  <div
                                    key={index}
                                    className={`progress-step ${index === currentSection ? 'active' : ''}`}
                                    onClick={() => setCurrentSection(index)}
                                  >
                                    <span className="step-number">{index + 1}</span>
                                    <span className="step-title">{displayTitle}</span>
                                  </div>
                                );
                              })}
                            </div>


                            <div className={`form-section ${darkMode ? "dark-background" : ""}`}>

                              <Typography
                                variant="h5"
                                className="form-title"
                                style={{
                                  marginBottom: '16px'
                                }}
                              >
                                {data?.form_name} {viewMode === 'editForm' && "(Edit)"}
                              </Typography>

                              <div className="section-fields-wrap">
                                {data.form_content
                                  .filter(
                                    content =>
                                      getQuestionTitle(content) ===
                                      Array.from(new Set(data.form_content.map(content => getQuestionTitle(content))))[currentSection]
                                  )
                                  .map((question, index) => {
                                    const questionLabel = getQuestionLabel(question);
                                    const questionResponse = responses[currentSection]?.[questionLabel] || "";
                                    const isQuestionRequired = question.required !== false;

                                    return (
                                      <div className="form-group question-group" key={index} style={{ marginBottom: "20px" }}>
                                         {question.type === 'checkbox' ? (
                                           <FormControl component="fieldset" style={{ width: "100%", textAlign: "left", alignItems: "flex-start" }}>
                                             <FormLabel component="legend" className="form-360-legend" required={isQuestionRequired} style={{ textAlign: "left", width: "100%", marginLeft: 0 }}>
                                               {questionLabel}
                                             </FormLabel>
                                             <div className="checkbox-group" style={{ marginTop: "8px" }}>
                                               {question.options && question.options.map((option, idx) => (
                                                 <FormControlLabel
                                                   key={idx}
                                                   control={
                                                     <Checkbox
                                                       checked={getSelectedValues(responses[currentSection]?.[questionLabel], question.options).includes(option)}
                                                       onChange={(e) =>
                                                         handleResponseChange(currentSection, index, option, questionLabel, 'checkbox')
                                                       }
                                                     />
                                                   }
                                                   label={option}
                                                 />
                                               ))}
                                             </div>
                                           </FormControl>
                                         ) : question.type === 'radio' ? (
                                           <FormControl component="fieldset" style={{ width: "100%", textAlign: "left", alignItems: "flex-start" }}>
                                             <FormLabel component="legend" className="form-360-legend" required={isQuestionRequired} style={{ textAlign: "left", width: "100%", marginLeft: 0 }}>
                                               {questionLabel}
                                             </FormLabel>
                                             <RadioGroup
                                               name={`question-${currentSection}-${index}`}
                                               value={questionResponse}
                                               onChange={(e) =>
                                                 handleResponseChange(currentSection, index, e.target.value, questionLabel, 'radio')
                                               }
                                               style={{ marginTop: "8px" }}
                                             >
                                               {question.options && question.options.map((option, idx) => (
                                                 <FormControlLabel
                                                   key={idx}
                                                   value={option ? option.toString() : ""}
                                                   control={<Radio />}
                                                   label={option}
                                                   style={{ marginRight: '16px' }}
                                                 />
                                               ))}
                                             </RadioGroup>
                                           </FormControl>
                                        ) : question.type === 'select' || question.type === 'dropdown' ? (
                                          <FormControl
                                            variant="outlined"
                                            fullWidth
                                            required={isQuestionRequired}
                                            error={!!errors[questionLabel]}
                                          >
                                            <InputLabel id={`question-select-${currentSection}-${index}`}>
                                              {questionLabel}
                                            </InputLabel>
                                            <Select
                                              labelId={`question-select-${currentSection}-${index}`}
                                              label={questionLabel}
                                              value={questionResponse}
                                              onChange={(e) =>
                                                handleResponseChange(currentSection, index, e.target.value, questionLabel, question.type)
                                              }
                                              onBlur={() =>
                                                handleResponseBlur(currentSection, index, questionResponse, questionLabel, question.type)
                                              }
                                              className="styled-select"
                                            >
                                              <MenuItem value="" disabled>Select</MenuItem>
                                              {question.options && question.options.map((option, idx) => (
                                                <MenuItem key={idx} value={option}>{option}</MenuItem>
                                              ))}
                                            </Select>
                                          </FormControl>
                                        ) : question.type === 'textarea' ? (
                                          <TextField
                                            fullWidth
                                            required={isQuestionRequired}
                                            multiline
                                            rows={4}
                                            variant="outlined"
                                            label={questionLabel}
                                            name={questionLabel}
                                            value={questionResponse}
                                            onChange={(e) =>
                                              handleResponseChange(currentSection, index, e.target.value, questionLabel, question.type)
                                            }
                                            onBlur={() =>
                                              handleResponseBlur(currentSection, index, questionResponse, questionLabel, question.type)
                                            }
                                            error={!!errors[questionLabel]}
                                          />
                                        ) : (
                                          <TextField
                                            fullWidth
                                            required={isQuestionRequired}
                                            type={question.type || "text"}
                                            variant="outlined"
                                            label={questionLabel}
                                            name={questionLabel}
                                            value={questionResponse}
                                            onChange={(e) =>
                                              handleResponseChange(currentSection, index, e.target.value, questionLabel, question.type)
                                            }
                                            onBlur={() =>
                                              handleResponseBlur(currentSection, index, questionResponse, questionLabel, question.type)
                                            }
                                            error={!!errors[questionLabel]}
                                            InputLabelProps={question.type === 'date' ? { shrink: true } : undefined}
                                          />
                                        )}

                                        {errors[questionLabel] && (
                                          <span className="field-error">
                                            {errors[questionLabel]}
                                          </span>
                                        )}
                                      </div>
                                    );
                                  })}
                              </div>

                              <div className="form-navigation">
                                {currentSection >= 0 && (
                                  <Button
                                    variant="contained"
                                    className="common-step-navigation-button"
                                    onClick={handlePrevious}
                                    style={previousButtonStyle}
                                  >
                                    Previous
                                  </Button>
                                )}
                                <Button
                                  variant="contained"
                                  color="primary"
                                  className="common-step-navigation-button"
                                  onClick={handleNext}
                                  style={navigationButtonStyle}
                                >
                                  {currentSection === Array.from(new Set(data.form_content.map(content => getQuestionTitle(content)))).length - 1 ? (viewMode === 'editForm' ? 'Update' : 'Submit') : 'Next'}
                                </Button>
                              </div>
                            </div>
                          </>
                        )}

                      {/* Thank You Section */}
                      {data && currentSection === Array.from(new Set(data.form_content ? data.form_content.map(content => getQuestionTitle(content)) : [])).length && (
                        <div>
                          <Typography variant="h4" style={{ color: '#4caf50' }}>
                            Thank you for your submission!
                          </Typography>
                        </div>
                      )}
                    </form>
                  </div>
                )}
              </div>
            )}

            {viewMode === 'list' && (
              <div style={{ marginBottom: '80px', marginTop: '62px' }}>
                <TableComponent
                  {...props}
                  shellClassName="holiday-table-shell"
                  tableTh={tableTh}
                  tableData={reviewformlistdata.map((item, index) => ({
                    ...item,
                    serial_number: index + 1,
                    select: (
                      <div className="wrap-check-20">
                        <label>
                          <input
                            type="checkbox"
                            checked={selectedRows.includes(item.id)}
                            onChange={() => handleSelectRow(item.id)}
                          />
                          <span className="checkbox"></span>
                        </label>
                      </div>
                    )
                  }))}
                  tableCount={reviewformlistdata.length}
                  isLoading={isListLoading}
                  tablePagestatus={false}
                  colNameToShow={['select', 'serial_number', 'form_name', 'first_name']}
                  actionBtns={[
                    hasPermission('Form360.View') && 'view',
                    hasPermission('Form360.Edit') && 'editNew',
                    hasPermission('Form360.Delete') && 'delete',
                  ].filter(Boolean)}
                  openPopUp={false}
                  openPopUpUpdate={false}
                  modelName="Feedback Forms"
                  showRow={(row) => { handleViewClick(row); }}
                  removeRow={(id) => handleDeleteClick(id)}
                  viewDetails={(row) => handleViewClick(row)}
                  handleEditClick={(row) => startEditing(row)}
                  selected={selectedRows}
                  setSelected={setSelectedRows}
                  selectableRows={true}
                  onPageChange={() => {}}
                  onRowsPerPageChange={() => {}}
                  bottomBarContent={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <Select
                        value={selectedBulkAction}
                        onChange={(e) => setSelectedBulkAction(e.target.value)}
                        displayEmpty
                        style={{ minWidth: '140px', height: '36px', backgroundColor: 'transparent' }}
                        MenuProps={{ classes: { paper: 'filter-time-entries-menu' } }}
                      >
                        <MenuItem value="" disabled>Bulk Action</MenuItem>
                        <MenuItem value="delete">Delete</MenuItem>
                      </Select>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleBulkActionSubmit}
                        disabled={!selectedBulkAction || selectedRows.length === 0}
                        style={{ textTransform: 'capitalize' }}
                      >
                        Go
                      </Button>
                    </div>
                  }
                  bottomBarClassName="user-check-table-bottom-bar"
                />

                <Dialog
                  open={openDialog}
                  onClose={handleCloseDialog}
                  disableScrollLock={true}
                  maxWidth="md"
                  fullWidth
                  PaperProps={{
                    style: {
                      borderRadius: '14px',
                      boxShadow: '0 8px 30px rgba(3, 109, 218, 0.18)',
                      overflow: 'hidden'
                    }
                  }}
                >
                  <DialogTitle disableTypography className="form360-view-dialog-title">
                    <div className="form360-view-dialog-title-text">
                      <VisibilityIcon style={{ fontSize: '20px', color: '#ffffff' }} />
                      <span>Form Details</span>
                    </div>
                    <IconButton
                      onClick={handleCloseDialog}
                      size="small"
                      className="form360-view-dialog-close-btn"
                    >
                      <CloseIcon style={{ color: '#ffffff', fontSize: '20px' }} />
                    </IconButton>
                  </DialogTitle>

                  <DialogContent className="form360-view-dialog-content">
                    {selectedData && (
                      <div>
                        <div className="form360-view-header-card">
                          <div className="form360-view-header-item">
                            <span className="form360-view-header-label">Form Name</span>
                            <span className="form360-view-header-value">{selectedData.form_name}</span>
                          </div>
                          <div className="form360-view-header-divider" />
                          <div className="form360-view-header-item">
                            <span className="form360-view-header-label">User ID</span>
                            <span className="form360-view-header-value">#{selectedData.user_id}</span>
                          </div>
                          {selectedData.created_at && (
                            <>
                              <div className="form360-view-header-divider" />
                              <div className="form360-view-header-item">
                                <span className="form360-view-header-label">Submitted On</span>
                                <span className="form360-view-header-value">
                                  {selectedData.created_at.replace('T', ' ').split('.')[0]}
                                </span>
                              </div>
                            </>
                          )}
                        </div>

                        {selectedData.data && (
                          <div>
                            {Object.entries(selectedData.data).map(([sectionTitle, sectionData]) => (
                              <div key={sectionTitle} className="form360-view-section-card">
                                <div className="form360-view-section-header">
                                  <h4>{sectionTitle.replace(/_/g, ' ')}</h4>
                                </div>

                                <div className="form360-view-fields-grid">
                                  {Object.entries(sectionData).map(([key, value]) => (
                                    <fieldset key={key} className="form360-view-fieldset">
                                      <legend className="form360-view-legend">
                                        {key.replace(/_/g, ' ')}
                                      </legend>
                                      <div className="form360-view-field-value-inner">
                                        {Array.isArray(value) ? (
                                          <div className="form360-view-chips-wrap">
                                            {value.map((option, idx) => (
                                              <span key={idx} className="form360-view-chip">
                                                ✓ {option}
                                              </span>
                                            ))}
                                          </div>
                                        ) : typeof value === 'boolean' ? (
                                          <span className={`form360-view-badge ${value ? 'active' : 'inactive'}`}>
                                            {value ? 'Yes' : 'No'}
                                          </span>
                                        ) : (
                                          <span className="form360-view-text-value">
                                            {value !== null && value !== undefined && value !== '' ? value.toString() : '—'}
                                          </span>
                                        )}
                                      </div>
                                    </fieldset>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </DialogContent>
                </Dialog>
              </div>
            )}
          </>
        }
      />
      <Footer {...props} />
    </div>
  );
}
